import { Accordion, Divider } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import './AccordionList.less';

type AccordionListProps<T> = {
  items: T[];
  // Callback appelé pour savoir s'il y aura un contenu
  itemHasContent?: (item: T) => boolean;
  // Composant pour le titre
  title: React.ComponentType<{ item: T }>;
  // Composant pour le contenu
  content: React.ComponentType<{ item: T }>;
};

const AccordionList = <T extends Record<string, unknown>>(props: AccordionListProps<T>) => {
  const { items, itemHasContent, title, content } = props;

  const [actives, setActives] = React.useState<number[]>([]);

  const handleClick = React.useCallback(
    (index) => {
      if (_.includes(actives, index)) {
        setActives(_.without(actives, index));
      } else {
        setActives([...actives, index]);
      }
    },
    [actives],
  );

  return (
    <Accordion className="accordion-list">
      {_.map(items, (item, i) => {
        const hasContent = itemHasContent?.(item) || false;

        return (
          <>
            <Accordion.Panel
              data-testid={`item-panel-${i}`}
              index={i}
              active={_.includes(actives, i)}
              title={{
                'data-testid': `item-title-${i}`,
                content: React.createElement(title, { item }),
              }}
              {...(hasContent && {
                onTitleClick: () => handleClick(i),
                content: {
                  content: React.createElement(content, { item }),
                },
              })}
            />
            {i < _.size(items) - 1 && <Divider />}
          </>
        );
      })}
    </Accordion>
  );
};

export default AccordionList;
